import React, { useState } from 'react'
import { Dropdown } from 'src/editor/shared/ui-lib/dropdown'
import { dropdownTitlesLocoKeys } from './consts'
import { WebsiteDropdownTitles, WebsiteThemeGroupType } from './types'
import { ColorCircle } from 'src/editor/shared/ui-lib/color-circle'
import { useTranslation } from 'react-i18next'

interface WebsiteThemeDropdownProps<T> {
  data: T
  title: string
}

export const WebsiteThemeDropdown = <T extends WebsiteThemeGroupType>({
  data,
  title,
}: WebsiteThemeDropdownProps<T>) => {
  const { t } = useTranslation()
  return (
    <Dropdown title={title} classNameDropdown="flex flex-col gap-4">
      {Object.entries(data).map(el => (
        <div key={el[0]} className="flex items-center justify-between">
          <h5 className="text-M text-textPrimary">
            {t(dropdownTitlesLocoKeys[el[0] as WebsiteDropdownTitles])}
          </h5>
          <div>
            {typeof el[1] === 'string' ? (
              // @TODO: will be change to a new color picker
              <ColorCircle color={el[1]} className="cursor-pointer" />
            ) : (
              // @TODO: will be change to a new background position style
              <span className="cursor-pointer text-M text-textLink">
                Upload
              </span>
            )}
          </div>
        </div>
      ))}
    </Dropdown>
  )
}
